import { render, staticRenderFns } from "./help-message-list.vue?vue&type=template&id=1f81a874&scoped=true"
import script from "./help-message-list.vue?vue&type=script&lang=js"
export * from "./help-message-list.vue?vue&type=script&lang=js"
import style0 from "./help-message-list.vue?vue&type=style&index=0&id=1f81a874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81a874",
  null
  
)

export default component.exports